var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReelRightIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 246,
    viewBox: "0 0 49 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1795_190597)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6448 14.7248C29.6605 12.5888 26.4812 12.5888 24.497 14.7248L24.4595 14.7651C23.5452 15.7493 21.9872 15.7493 21.0728 14.7651L21.0354 14.7248C19.0511 12.5888 15.8718 12.5888 13.8876 14.7248C11.8581 16.9094 11.8581 20.4842 13.8876 22.6688L22.7662 32.2263L31.6448 22.6688C33.6742 20.4842 33.6742 16.9094 31.6448 14.7248ZM22.8036 13.1517C25.7022 10.0315 30.4395 10.0315 33.3381 13.1517C36.1915 16.2232 36.1915 21.1704 33.3381 24.2419L24.4595 33.7993C23.5452 34.7836 21.9872 34.7836 21.0728 33.7993L12.1942 24.2419C9.34086 21.1704 9.34086 16.2232 12.1942 13.1517C15.0928 10.0315 19.8301 10.0315 22.7287 13.1517L22.7662 13.192L22.8036 13.1517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3633 84.3544C25.9646 85.205 24.3223 85.6949 22.5656 85.6949C17.4589 85.6949 13.3192 81.5551 13.3192 76.4484C13.3192 71.3418 17.4589 67.202 22.5656 67.202C27.6723 67.202 31.8121 71.3418 31.8121 76.4484C31.8121 78.7476 30.9729 80.8507 29.5842 82.4683C29.5464 82.5124 29.5082 82.5561 29.4696 82.5994L29.9658 84.9126L27.3633 84.3544ZM31.9573 83.1835C33.3187 81.2875 34.1219 78.9598 34.1219 76.4484C34.1219 70.066 28.948 64.8921 22.5656 64.8921C16.1832 64.8921 11.0093 70.066 11.0093 76.4484C11.0093 82.8308 16.1832 88.0048 22.5656 88.0048C24.4147 88.0048 26.1671 87.5689 27.7207 86.7935L32.9733 87.9202L31.9573 83.1835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8826 124.766C10.5806 123.65 11.3698 121.517 13.0846 121.517H32.4967C33.9324 121.517 34.8191 123.083 34.0805 124.314L24.3521 140.528C23.4934 141.959 21.3274 141.608 20.9654 139.979L18.9266 130.804L11.8826 124.766ZM21.4418 130.77L23.0345 137.938L30.2376 125.933L21.4418 130.77ZM28.6783 123.98H14.7489L20.1934 128.646L28.6783 123.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.9003,
    cy: 173.222,
    r: 1.77727,
    transform: "rotate(-90 16.9003 173.222)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.766,
    cy: 173.222,
    r: 1.77727,
    transform: "rotate(-90 22.766 173.222)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.632,
    cy: 173.222,
    r: 1.77727,
    transform: "rotate(-90 28.632 173.222)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4547 207.835L17.1908 211.099C17.1773 211.113 17.1634 211.127 17.1492 211.141C16.9944 211.297 16.7996 211.493 16.5611 211.639C16.3543 211.765 16.1288 211.859 15.893 211.915C15.621 211.981 15.3447 211.98 15.1252 211.979C15.1051 211.979 15.0854 211.979 15.0662 211.979H13.0586C12.7159 211.979 12.5284 211.98 12.3937 211.991C12.3883 211.992 12.3833 211.992 12.3785 211.993C12.378 211.997 12.3776 212.002 12.3771 212.008C12.3661 212.143 12.3652 212.33 12.3652 212.673V218.22C12.3652 218.562 12.3661 218.75 12.3771 218.885C12.3776 218.89 12.378 218.895 12.3785 218.9C12.3833 218.9 12.3883 218.901 12.3937 218.901C12.5284 218.912 12.7159 218.913 13.0586 218.913H15.0662C15.0854 218.913 15.1051 218.913 15.1252 218.913C15.3447 218.912 15.621 218.912 15.893 218.977C16.1288 219.034 16.3543 219.127 16.5611 219.254C16.7996 219.4 16.9944 219.596 17.1492 219.751C17.1634 219.766 17.1773 219.78 17.1908 219.793L20.4547 223.057V207.835ZM20.8965 204.712C21.4496 204.669 21.9902 204.893 22.3506 205.315C22.6733 205.693 22.7246 206.147 22.7441 206.368C22.766 206.615 22.766 206.922 22.7659 207.234V223.658C22.766 223.97 22.766 224.278 22.7441 224.525C22.7246 224.745 22.6733 225.2 22.3506 225.578C21.9902 226 21.4496 226.224 20.8965 226.18C20.4011 226.141 20.0435 225.856 19.8737 225.714C19.6834 225.554 19.4662 225.337 19.2453 225.116L15.5565 221.427C15.4495 221.32 15.3959 221.267 15.3553 221.23C15.3542 221.229 15.3532 221.228 15.3522 221.227C15.3509 221.227 15.3495 221.227 15.3481 221.227C15.2932 221.225 15.2176 221.224 15.0662 221.224L13.0218 221.224C12.7301 221.224 12.446 221.224 12.2055 221.205C11.9413 221.183 11.6296 221.132 11.3159 220.972C10.881 220.751 10.5275 220.397 10.3059 219.962C10.1461 219.649 10.0951 219.337 10.0735 219.073C10.0539 218.832 10.0539 218.548 10.054 218.257L10.054 212.673C10.054 212.66 10.054 212.648 10.054 212.636C10.0539 212.344 10.0539 212.06 10.0735 211.82C10.0951 211.555 10.1461 211.244 10.3059 210.93C10.5275 210.495 10.881 210.142 11.3159 209.92C11.6296 209.76 11.9413 209.709 12.2055 209.688C12.446 209.668 12.7301 209.668 13.0218 209.668C13.034 209.668 13.0463 209.668 13.0586 209.668H15.0662C15.2176 209.668 15.2932 209.668 15.3481 209.665C15.3495 209.665 15.3509 209.665 15.3522 209.665C15.3532 209.664 15.3542 209.663 15.3553 209.662C15.3959 209.625 15.4495 209.572 15.5565 209.465L19.2149 205.807C19.2251 205.796 19.2352 205.786 19.2453 205.776C19.4662 205.555 19.6834 205.338 19.8737 205.179C20.0435 205.036 20.4011 204.751 20.8965 204.712ZM31.0448 206.419C31.5629 206.046 32.2851 206.164 32.6578 206.682C34.4324 209.149 35.4779 212.177 35.4779 215.446C35.4779 218.715 34.4324 221.744 32.6578 224.211C32.2851 224.729 31.5629 224.846 31.0448 224.474C30.5267 224.101 30.4088 223.379 30.7816 222.861C32.2827 220.774 33.1666 218.215 33.1666 215.446C33.1666 212.677 32.2827 210.118 30.7816 208.032C30.4088 207.514 30.5267 206.791 31.0448 206.419ZM26.433 209.876C26.9565 209.511 27.6768 209.639 28.042 210.163C29.0868 211.66 29.6997 213.484 29.6997 215.446C29.6997 217.409 29.0868 219.232 28.042 220.73C27.6768 221.253 26.9565 221.382 26.433 221.017C25.9095 220.651 25.7812 219.931 26.1463 219.408C26.9294 218.285 27.3885 216.921 27.3885 215.446C27.3885 213.971 26.9294 212.607 26.1463 211.485C25.7812 210.961 25.9095 210.241 26.433 209.876Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1795_190597",
    x: 0.898438,
    y: 0.5,
    width: 55.7351,
    height: 248.814,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.164706 0 0 0 0 0.282353 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1795_190597"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1795_190597",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelRightIcons);
export default __webpack_public_path__ + "static/media/reelRightIcons.1e4a2559.svg";
export { ForwardRef as ReactComponent };